const $inject = ['$http', '$q', 'moment', 'userProfileService', 'apiService'];

const userFeedService = ($http, $q, moment, userProfileService, apiService) => {
  const service = {
    getFeed: get,
    setFeed: set,
    feed: null
  };

  const welcomeCardKeys = [
    'HasAddedCreditCard',
    'HasAddedMemberships',
    'HasAddedRules',
    'HasCompletedProfile',
    'HasInvitedTeam',
    'HasMadeBooking'
  ];

  return service;

  function set(feed) {
    service.feed = feed;
    return service.feed;
  }

  function get() {
    const deferred = $q.defer();

    const apiUrl = apiService.getUrl('userActivity', { debtorId: userProfileService.profile.DebtorIdentifier });

    $http.get(apiUrl).then((response) => {
      deferred.resolve(process(response.data));
    }, () => {
      deferred.reject();
    });

    return deferred.promise;
  }

  function process(feed) {
    const welcomeCards = _.filter(welcomeCardKeys, (cardKey) => {
      return !feed[cardKey];
    });

    const timeline = groupTimelineEvents(feed.Feed.Events);

    return _.extend(feed, {
      WelcomeCards: welcomeCards,
      Timeline: timeline
    });
  }

  function groupTimelineEvents(events) {
    const groups = {};
    const sortedEvents = _.orderBy(events, ['Date'], ['desc']);

    _.forEach(sortedEvents, (event) => {
      const label = dateLabel(event.Date);
      groups[label] = groups[label] || [];
      groups[label].push(event);
    });

    _.forIn(groups, (groupItems, groupKey) => {
      groups[groupKey] = _.orderBy(groupItems, ['Date'], ['desc']);
    });

    return groups;
  }

  function dateLabel(date) {
    const displayFormat = 'dddd Do MMMM YYYY';
    const dateMoment = moment(date);
    const fromToday = daysFromToday(dateMoment);

    if(fromToday === -1) {
      return 'Tomorrow';
    }

    if(fromToday === 0) {
      return 'Today';
    }

    if(fromToday === 1) {
      return 'Yesterday';
    }

    return dateMoment.format(displayFormat);
  }

  function daysFromToday(dateMoment) {
    return moment().startOf('day').diff(dateMoment.startOf('day'), 'days');
  }
};

userFeedService.$inject = $inject;

export default userFeedService;


// WEBPACK FOOTER //
// ./src/services/userFeedService.js